import OriginalCarousel from 'react-bootstrap/Carousel';
const Carousel = OriginalCarousel;
Carousel.PREV = 'prev';
Carousel.NEXT = 'next';
export default Carousel;
